import {Component, Prop} from 'vue-property-decorator'
import * as Vue from "vue-tsx-support";
import "vue-tsx-support/enable-check"
import {default as Page, PageProps} from "../../types/iview/Page";
import './pageCustom.less'
import { createBEM } from 'src/util/bem';
export interface PageCustomProps extends PageProps {
	pageChanged?(pageNum: number): void
	pageSizeChanged?(pageSize: number): void
}
let bem = createBEM('page')

@Component
export default class PageCustom extends Vue.Component<PageCustomProps> {
	@Prop({
		type: Number,
		default: 0
	})
	total!: number

	@Prop({
		type: Number,
		default: 10
	})
	pageSize!: number

	@Prop({
		type: Array,
		default: () => {
			return [5,10, 20, 50, 100, 200]
		}
	})
	pageSizeOpts!: Array<number>

	@Prop({
		type: Number
	})
	current!: number

	@Prop({
		type: Function,
		default: ()=>{}
	})
	pageSizeChanged!: () => void

	@Prop({
		type: Function,
		default: ()=>{}
	})
	pageChanged!: () => void

	render(h) {
		return(
			<Page
				class={['wqms-pa5 ', bem()]}
				current={this.current}
				total={this.total}
				pageSize={this.pageSize}
				pageSizeOpts={this.pageSizeOpts}
				showElevator={true}
				showSizer={true}
				showTotal={true}
				onOn-change={this.pageChanged}
                onOn-page-size-change={this.pageSizeChanged}
                prev-text="上一页" next-text="下一页"
			></Page>
		)
	}

}
